export default {
    requirements: {
        low: {
            id: 'low',
            name: 'Low',
            totalFootage: 36,
            staffing: 0,
            staffingCode: "ddps",
            equipment: ["Viewing Booth"],
            software: [],
            otherItems: []
        },

        medium: {
            id: 'medium',
            name: 'Medium',
            totalFootage: 36,
            staffing:0.05,
            staffingCode: "ddps",
            equipment: ["Densitometer/viewing booth"],
            software: ["profiling software"],
            otherItems: []
        },

        high: {
            id: 'high',
            name: 'High',
            totalFootage: 36,
            staffing: 0.1,
            staffingCode: "ddps",
            equipment: ["Densitometer/viewing booth/spectrophotometer"],
            software: ["G7 software"],
            otherItems: []
        },
    },

    ratingDetails: [
        {
            id: 'level',
            type: 'enum',
            required: false,
            component: 'PulloutQuestionMultiSwitchList',
            default: 0,
            label: "Level of Need:",
            options: [
                {
                    id: "none",
                    label: "None",
                    value: 0
                },

                {
                    id: "low",
                    label: "Low",
                    description: "Color Calibration",
                    value: 1
                },
                {
                    id: "medium",
                    label: "Medium",
                    description: "Fingerprinting (7 hrs per month)",
                    value: 2
                },
                {
                    id: "high",
                    label: "High",
                    description: "G7 Certification (14 hrs per month)",
                    value: 3
                }
            ]
        }

    ]
}
